import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import Vue           from 'vue'

Vue.component('date-picker', VuePersianDatetimePicker);